// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__v3i_y","boxInner":"Box_boxInner__A76q8","boxInnerBig":"Box_boxInnerBig__dyf4K"};